import MultipleChoice from './multiple-choice.tsx';
import { Reorder } from 'framer-motion';
import { Dispatch, SetStateAction } from 'react';
import { toast } from 'react-toastify';
import { IMultipleAnswer } from '../create-question-form.tsx';
import PlusIcon from '../../../../assets/icons/plus.svg?react';
import { orderToLetter } from '../../../../utils/common-utils.ts';

interface IMultipleChoices {
  addChoice: () => void;
  multipleAnswers: IMultipleAnswer[];
  setMultipleAnswers: Dispatch<SetStateAction<IMultipleAnswer[]>>;
}

const MultipleChoices = ({
  addChoice,
  multipleAnswers,
  setMultipleAnswers,
}: IMultipleChoices) => {
  const onRemove = (id: string) => {
    if (multipleAnswers.length <= 2) {
      toast.error('You must have at least two answers');
      return;
    }
    setMultipleAnswers((prevState) =>
      prevState.filter((answer) => answer.id !== id),
    );
  };

  const onClickCorrect = (id: string) => {
    setMultipleAnswers((prevState) =>
      prevState.map((answer) => {
        if (answer.id === id) return { ...answer, correct: true };
        return { ...answer, correct: false };
      }),
    );
  };

  const onChange = (id: string, text: string) => {
    setMultipleAnswers((prevState) =>
      prevState.map((answer) => {
        if (answer.id === id) return { ...answer, text };
        return answer;
      }),
    );
  };

  return (
    <div className={'w-full'}>
      <Reorder.Group
        axis="y"
        values={multipleAnswers}
        onReorder={setMultipleAnswers}
        className={'overflow-hidden py-2'}
      >
        {multipleAnswers.map((answer, index) => {
          return (
            <MultipleChoice
              key={answer.id}
              index={index}
              answer={answer}
              onChange={onChange}
              onClickCorrect={onClickCorrect}
              onRemove={onRemove}
            />
          );
        })}
      </Reorder.Group>

      <button
        type="button"
        className="ml-[-0.25rem] mt-1 flex items-center text-sm font-medium text-gray transition-opacity hover:opacity-80"
        onClick={addChoice}
      >
        <div className="flex items-center min-w-[3.75rem]">
          <span className="mx-2 font-semibold">
            {orderToLetter(multipleAnswers.length)}.
          </span>
        </div>

        <span className="mr-2 flex h-8 w-8 items-center justify-center rounded-md border border-disabled bg-opacity-65">
          <PlusIcon width={28} height={28} />
        </span>

        <span className="text-xs font-semibold uppercase tracking-[0.08em]">
          Add choice
        </span>
      </button>
    </div>
  );
};
export default MultipleChoices;
